import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
interface PageHeroProps {
  title: string;
  subtitle?: string;
  breadcrumb: string;
}
export function PageHero({
  title,
  subtitle,
  breadcrumb
}: PageHeroProps) {
  return <section className="bg-au-green text-white" data-id="element-231">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20" data-id="element-232">
        <nav aria-label="Breadcrumb" className="flex items-center text-sm text-green-100 mb-4" data-id="element-233">
          <Link to="/" className="hover:text-au-gold transition-colors" data-id="element-234">
            Home
          </Link>
          <ChevronRight size={16} className="mx-2 text-green-200" data-id="element-235" />
          <span className="text-white font-medium" data-id="element-236">{breadcrumb}</span>
        </nav>
        <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4" data-id="element-237">
          {title}
        </h1>
        <div className="h-1 w-16 bg-au-gold mb-6" data-id="element-238"></div>
        {subtitle && <p className="text-lg text-green-50 max-w-2xl leading-relaxed" data-id="element-239">
            {subtitle}
          </p>}
      </div>
    </section>;
}